/**
 * Dark + light theme tokens for the marketing landing page.
 *
 * Inline styles (not MUI theme) because the landing sits OUTSIDE the
 * dashboard's ThemeProvider — different visual language and shipping
 * the dashboard's bundle here would be wasteful. Each sub-component
 * imports `DARK`, `LIGHT`, and `glassStyle` from this module so a
 * color change is a one-file edit.
 */
export const DARK = {
  bg: 'linear-gradient(135deg, #050510 0%, #0D0D2B 50%, #0A0520 100%)',
  surface: 'rgba(255,255,255,0.07)',
  surfaceHover: 'rgba(255,255,255,0.12)',
  border: 'rgba(255,255,255,0.10)',
  text: '#ffffff',
  textSub: 'rgba(255,255,255,0.55)',
  textMuted: 'rgba(255,255,255,0.35)',
  navBg: 'rgba(5,5,16,0.88)',
  navBorder: 'rgba(255,255,255,0.06)',
  inputBg: 'rgba(255,255,255,0.07)',
  inputBorder: 'rgba(255,255,255,0.12)',
  orb1: 'rgba(124,58,237,0.38)',
  orb2: 'rgba(59,130,246,0.28)',
  orb3: 'rgba(99,102,241,0.22)',
  grid: 'rgba(255,255,255,0.025)',
};

export const LIGHT = {
  bg: 'linear-gradient(135deg, #F0EEFF 0%, #EAF0FF 50%, #F5EEFF 100%)',
  surface: 'rgba(255,255,255,0.75)',
  surfaceHover: 'rgba(255,255,255,0.95)',
  border: 'rgba(124,58,237,0.12)',
  text: '#1a1040',
  textSub: 'rgba(26,16,64,0.6)',
  textMuted: 'rgba(26,16,64,0.38)',
  navBg: 'rgba(240,238,255,0.92)',
  navBorder: 'rgba(124,58,237,0.1)',
  inputBg: 'rgba(255,255,255,0.8)',
  inputBorder: 'rgba(124,58,237,0.2)',
  orb1: 'rgba(124,58,237,0.18)',
  orb2: 'rgba(59,130,246,0.14)',
  orb3: 'rgba(99,102,241,0.12)',
  grid: 'rgba(124,58,237,0.04)',
};

/** Glass-card surface used by every section on the page. */
export function glassStyle(t, extra = {}) {
  return {
    background: t.surface,
    backdropFilter: 'blur(16px)',
    WebkitBackdropFilter: 'blur(16px)',
    border: `1px solid ${t.border}`,
    borderRadius: 20,
    ...extra,
  };
}
